import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
/* ==============================================
ヘッダーの部分
============================================== */
export function servicesFunc() {
  let servicesTop = $("#servicesTop").length;

  if (servicesTop) {
    // subNavHeightFunc();

    subNavAccordionFuc();

    subNavScrollFunc();

    // function subNavHeightFunc() {
    //   let subNavHeight = $(".subNav");
    //   let headerHeight = $("#header").outerHeight();
    //   subNavHeight.css("top", `${headerHeight}px`);

    //   let setTimer = false;
    //   $(window).on("resize", function () {
    //     if (setTimer !== false) {
    //       clearTimeout(setTimer);
    //     }
    //     setTimer = setTimeout(() => {
    //       subNavHeightFunc();
    //     }, 200);
    //   });
    // }

    function subNavAccordionFuc() {
      const servicesSubNavAccordionBtn = $("#servicesSubNav .accordionBtn");
      const servicesSubNav = $("#servicesSubNavList a");
      let resizecheck = $("#responsibleCheck").width();
      let resizecheck2 = 0;

      $(window).on("load resize", function () {
        resizecheck = $("#responsibleCheck").width();
        subNavAccordionMenuStart();
        subNavCloseFunc();
      });

      //スマホのみサブナビをクリックでクローズさせる
      function subNavCloseFunc() {
        if (resizecheck == "2") {
          servicesSubNav.on("click", subNavClickHandler);
        } else if (resizecheck == "1") {
          servicesSubNav.off("click", subNavClickHandler);
        }
      }
      function subNavClickHandler() {
        servicesSubNavAccordionBtn.next("dd").slideUp(500);
        $("#servicesSubNav").removeClass("isNavOpen");
        servicesSubNavAccordionBtn.removeClass("isOpen");
      }
      subNavCloseFunc();

      servicesSubNavAccordionBtn.on("click", function () {
        const subNav = $("#servicesSubNav");

        if (resizecheck == "2") {
          if ($(this).hasClass("isOpen")) {
            $(this)
              .next("dd")
              .slideUp(500, function () {
                subNav.removeClass("isNavOpen");
              });
            $(this).removeClass("isOpen");
          } else {
            servicesSubNavAccordionBtn.next("dd").slideUp(500);
            servicesSubNavAccordionBtn.removeClass("isOpen");
            $(this).next("dd").slideDown(500);
            $(this).addClass("isOpen");

            subNav.addClass("isNavOpen");
          }
        }
      });

      var subNavAccordionMenuStart = function () {
        let resizecheck = $("#responsibleCheck").width();
        if (resizecheck == "2" && resizecheck != resizecheck2) {
          servicesSubNavAccordionBtn.next("dd").css("display", "none");
          resizecheck2 = 2;
        } else if (resizecheck == "1" && resizecheck != resizecheck2) {
          servicesSubNavAccordionBtn.removeClass("isOpen");
          servicesSubNavAccordionBtn.next("dd").css("display", "block");
          resizecheck2 = 1;
        }
      };
      subNavAccordionMenuStart();
    }

    function subNavScrollFunc() {
      // 今回の交差を監視する要素
      const boxes = document.querySelectorAll(".servicesList .list");

      const options = {
        root: null,
        rootMargin: "0% 0px -87%",
        threshold: 0,
      };
      const observer = new IntersectionObserver(doWhenIntersect, options);
      boxes.forEach((box) => {
        observer.observe(box);
      });

      /**
       * 交差したときに呼び出す関数
       * @param entries
       */
      function doWhenIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activateIndex(entry.target);
          }
        });
      }
      /**
       * 目次を変える関数
       * @param element
       */
      function activateIndex(element) {
        const currentActiveIndex = document.querySelector("#servicesSubNavList .active");
        if (currentActiveIndex !== null) {
          currentActiveIndex.classList.remove("active");
        }
        const newActiveIndex = document.querySelector(`a[href='#${element.id}']`).parentElement;
        newActiveIndex.classList.add("active");

        const currentTxt = document.querySelector(`a[href='#${element.id}']`).textContent;
        $("#navCurrent").text(currentTxt).css({ color: "#fff" });
      }
    }

    $(window).on("load scroll", function () {
      var subNavCurrent = $("#servicesSubNavList .pageLinkList");
      var scroll = $(window).scrollTop();
      if (scroll == 0) {
        $("#navCurrent").text("TENGA 20th Anniversary").css({ color: "#fff" });
        if (subNavCurrent.hasClass("active")) {
          subNavCurrent.removeClass("active");
        }
      }
    });
  }
}

export function animation() {
  // 商品ホバー時（PC）
  $(function () {
    $(".productItemOther").each(function (index) {
      $(this).on("mouseenter", function () {
        // 全キャラを一旦リセット
        $(".productCharaItem").css("opacity", "1");

        // キャラ 0.7
        $(".productCharaItem").eq(index).css("opacity", ".7");

        // 商品 0.7
        $(this).find(".product__swiper-slide-img, .product__swiper-slide-txt-wrap").css("opacity", ".7");
      });

      $(this).on("mouseleave", function () {
        // 全てを元に戻す
        $(".productCharaItem").css("opacity", "1");
        $(this).find(".product__swiper-slide-img, .product__swiper-slide-txt-wrap").css("opacity", "1");
      });
    });
  });
  // 商品ホバー時（SP）

  /* =============================================
gsap
============================================= */
  // FV
  // FV
  window.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger, CustomEase);
    const isSP = window.matchMedia("(max-width: 767px)").matches;

    // 参考サイトの「cubic-bezier(0.445, 0.05, 0.55, 0.95)」に一番近いGSAPの滑らかなイージング
    CustomEase.create("siteEase", "0.445, 0.05, 0.55, 0.95");
    const customEase = "siteEase";

    // =========================
    // PC
    // =========================
    if (!isSP) {
      let tl = gsap.timeline();

      // 1人目
      tl.fromTo(
        ".fvCharaBg.first",
        { clipPath: "inset(0 0 0 100%)" },
        {
          clipPath: "inset(0 0 0 0%)",
          duration: 0.3, // 参考サイト準拠
          ease: customEase,
        },
      );

      tl.fromTo(
        ".fvChara.first",
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 0.7, ease: customEase },
        ">-0.1", // 背景が開ききる少し手前からフェードイン
      );

      tl.fromTo(".fvProduct.first", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, "<");

      // 2人目
      tl.fromTo(
        ".fvCharaBg.second",
        { clipPath: "inset(0 0 0 100%)" },
        {
          clipPath: "inset(0 0 0 0%)",
          duration: 0.3,
          ease: customEase,
        },
        ">-0.4", // 1人目が出ている途中で次の背景を滑らかに開始
      );

      tl.fromTo(".fvChara.second", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, ">-0.1");

      tl.fromTo(".fvProduct.second", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, "<");

      // 3人目
      tl.fromTo(
        ".fvCharaBg.third",
        { clipPath: "inset(0 100% 0 0)" },
        {
          clipPath: "inset(0 0% 0 0)",
          duration: 0.3,
          ease: customEase,
        },
        ">-0.4",
      );

      tl.fromTo(".fvChara.third", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, ">-0.1");

      tl.fromTo(".fvProduct.third", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, "<");

      // 4人目
      tl.fromTo(
        ".fvCharaBg.four",
        { clipPath: "inset(0 100% 0 0)" },
        {
          clipPath: "inset(0 0% 0 0)",
          duration: 0.3,
          ease: customEase,
        },
        ">-0.4",
      );

      tl.fromTo(".fvChara.four", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, ">-0.1");

      tl.fromTo(".fvProduct.four", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, "<");

      // 【PCロゴ】元のタイミング指定「<1」をそのままキープ
      tl.fromTo(
        ".fvLogo1, .fvLogo2, .fvCopyright",
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          ease: "power1.inOut",
        },
        "<1",
      );
    }

    // =========================
    // SP
    // =========================
    else {
      let tl = gsap.timeline();

      // 1人目
      tl.fromTo(
        ".fvCharaBgSp.first",
        { clipPath: "inset(0 0 0 100%)" },
        {
          clipPath: "inset(0 0 0 0%)",
          duration: 0.3,
          ease: customEase,
        },
      );

      tl.fromTo(".fvCharaSp.first", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, ">-0.1");

      tl.fromTo(".fvProductSp.first", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, "<");

      // 2人目
      tl.fromTo(
        ".fvCharaBgSp.second",
        { clipPath: "inset(0 100% 0 0)" },
        {
          clipPath: "inset(0 0% 0 0)",
          duration: 0.3,
          ease: customEase,
        },
        ">-0.4",
      );

      tl.fromTo(".fvCharaSp.second", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, ">-0.1");

      tl.fromTo(".fvProductSp.second", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, "<");

      // 3人目
      tl.fromTo(
        ".fvCharaBgSp.third",
        { clipPath: "inset(0 0 0 100%)" },
        {
          clipPath: "inset(0 0 0 0%)",
          duration: 0.3,
          ease: customEase,
        },
        ">-0.4",
      );

      tl.fromTo(".fvCharaSp.third", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, ">-0.1");

      tl.fromTo(".fvProductSp.third", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, "<");

      // 4人目
      tl.fromTo(
        ".fvCharaBgSp.four",
        { clipPath: "inset(0 100% 0 0)" },
        {
          clipPath: "inset(0 0% 0 0)",
          duration: 0.3,
          ease: customEase,
        },
        ">-0.4",
      );

      tl.fromTo(".fvCharaSp.four", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, ">-0.1");

      tl.fromTo(".fvProductSp.four", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7, ease: customEase }, "<");

      // 【SPロゴ】元のタイミング指定「<1」をそのままキープ
      tl.fromTo(
        ".fvLogo1Sp, .fvLogo2Sp, .fvCopyrightSp",
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.5,
          ease: "power1.inOut",
        },
        "<1",
      );
    }
  });

  //各セクションごとのフェードイン
  gsap.utils.toArray(".fadeIn").forEach((target) => {
    gsap.fromTo(
      target,
      { autoAlpha: 0 },
      {
        autoAlpha: 1,
        scrollTrigger: {
          trigger: target,
          start: "top 70%",
          // markers:true,
        },
      },
    );
  });

  //帯（商品情報);
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const classesPC = ["chainsawman", "bomb", "makima", "aki"];
    const isSP = window.innerWidth <= 768;

    gsap.utils.toArray(".productItem").forEach((item) => {
      classesPC.forEach((cls, index) => {
        const deco = item.querySelector(`.productItemBg.${cls}`);

        if (!deco) return;

        const isReverse = cls === "aki";

        gsap.fromTo(
          deco,
          {
            clipPath: isReverse ? "inset(0 0 0 100%)" : "inset(0 100% 0 0)",
          },
          {
            clipPath: "inset(0 0% 0 0%)",
            duration: 0.5,
            ease: "power2.out",
            scrollTrigger: {
              trigger: item,
              start: `top ${50 + index * 2}%`,
              once: true,
              ...(isSP && {
                scroller: ".drawerScroll",
              }),
            },
          },
        );
      });
    });
  });

  //血飛沫（intro）;
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    const triggerOptions = {
      trigger: ".introInner",
      start: "top 60%",
    };

    if (isSP) {
      triggerOptions.scroller = ".drawerScroll";
    }

    gsap.fromTo(
      ".introDeco.first",
      { display: "none" },
      {
        display: "block",
        scrollTrigger: triggerOptions,
      },
    );

    const triggerOptions2 = {
      trigger: ".introInner",
      start: "bottom 90%",
    };

    if (isSP) {
      triggerOptions2.scroller = ".drawerScroll";
    }

    gsap.fromTo(
      ".introDeco.second",
      { display: "none" },
      {
        display: "block",
        scrollTrigger: triggerOptions2,
      },
    );
  });

  //血飛沫（商品情報）;
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    gsap.fromTo(
      ".productDeco",
      { display: "none" },
      {
        display: "block",
        scrollTrigger: {
          trigger: ".productWrap",
          start: "top 60%",
          ...(isSP && {
            scroller: ".drawerScroll",
          }),
        },
      },
    );
  });

  // 血飛沫（商品情報）
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    const scrollTriggerOption = isSP ? { scroller: ".drawerScroll" } : {};

    const classesPC = ["first", "second", "third", "four"];

    gsap.utils.toArray(".productItem").forEach((item) => {
      classesPC.forEach((cls, index) => {
        const deco = item.querySelector(`.productIdemDeco.${cls}`);

        if (!deco) return;

        const startOffset = 70 + index * 2;

        gsap.fromTo(
          deco,
          { display: "none" },
          {
            display: "block",
            scrollTrigger: {
              trigger: deco,
              start: `top ${startOffset}%`,
              ...scrollTriggerOption,
            },
          },
        );
      });
    });
  });

  //血飛沫（裏蓋について、SPEC）;
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    gsap.fromTo(
      ".productAboutDeco",
      { display: "none" },
      {
        display: "block",
        scrollTrigger: {
          trigger: ".productAboutInner",
          start: "top 60%",
          ...(isSP && {
            scroller: ".drawerScroll",
          }),
        },
      },
    );

    gsap.fromTo(
      ".productSpecDeco",
      { display: "none" },
      {
        display: "block",
        scrollTrigger: {
          trigger: ".productSpecInner",
          start: "top 50%",
          ...(isSP && {
            scroller: ".drawerScroll",
          }),
        },
      },
    );
  });

  // 血飛沫（s-meister）
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    gsap.fromTo(
      ".meisterDeco",
      { display: "none" },
      {
        display: "block",
        scrollTrigger: {
          trigger: ".meisterWrap",
          start: "top 60%",
          ...(isSP && {
            scroller: ".drawerScroll",
          }),
        },
      },
    );
  });

  //血飛沫（専用ボックス）;
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    gsap.fromTo(
      ".specialDeco",
      { display: "none" },
      {
        display: "block",
        scrollTrigger: {
          trigger: ".specialWrap",
          start: "top 60%",
          ...(isSP && {
            scroller: ".drawerScroll",
          }),
        },
      },
    );
  });

  // 血飛沫（Front&inside）
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    const classesPC = ["first", "second"];

    gsap.utils.toArray(".specialCont").forEach((item) => {
      classesPC.forEach((cls, index) => {
        const deco = item.querySelector(`.specialSlideDeco.${cls}`);

        if (!deco) return;

        const startOffset = 60 + index * 2;

        gsap.fromTo(
          deco,
          { display: "none" },
          {
            display: "block",
            scrollTrigger: {
              trigger: deco,
              start: `top ${startOffset}%`,
              ...(isSP && {
                scroller: ".drawerScroll",
              }),
            },
          },
        );
      });
    });
  });

  //血飛沫（取扱店舗）;
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const isSP = window.innerWidth <= 768;

    gsap.fromTo(
      ".shopListDecoTop",
      { display: "none" },
      {
        display: "block",
        scrollTrigger: {
          trigger: ".shopList",
          start: "top 60%",
          ...(isSP && {
            scroller: ".drawerScroll",
          }),
        },
      },
    );
  });

  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const scrollTriggerOption = window.innerWidth <= 768 ? { scroller: ".drawerScroll" } : {};

    gsap.to(".shopListDeco", {
      "--before-display": "block",
      scrollTrigger: {
        trigger: ".shopList",
        start: "20% 80%",
        ...scrollTriggerOption,
      },
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const drawerIcon = document.querySelector(".drawerIcon");
  const drawer = document.querySelector(".drawer");
  const drawerNavItem = document.querySelectorAll('.drawer a[href^="#"]');

  const breakpoint = 768;

  // アニメーション中判定
  let isAnimating = false;
  let closeTimer = null;

  // 開く
  const openMenu = () => {
    if (isAnimating) return;

    isAnimating = true;
    clearTimeout(closeTimer);

    drawer.classList.remove("is-closing");

    drawer.classList.add("js-show");
    drawerIcon.classList.add("js-show");

    document.body.classList.add("is-lock");

    setTimeout(() => {
      isAnimating = false;
    }, 500);
  };

  // 閉じる
  const closeMenu = () => {
    if (isAnimating) return;

    isAnimating = true;

    drawer.classList.add("is-closing");
    drawerIcon.classList.remove("js-show");

    setTimeout(() => {
      drawer.classList.remove("js-show");
      drawer.classList.remove("is-closing");

      document.body.classList.remove("is-lock");

      isAnimating = false;
    }, 500);
  };

  // 開閉
  const toggleMenu = () => {
    if (isAnimating) return;

    if (drawer.classList.contains("js-show")) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  // リサイズ
  const handleResize = () => {
    if (window.innerWidth > breakpoint) {
      closeMenu();
    }
  };

  // 外クリック
  const clickOuter = (event) => {
    if (drawer.classList.contains("js-show") && !drawer.contains(event.target) && !drawerIcon.contains(event.target)) {
      closeMenu();
    }
  };

  // ハンバーガー
  drawerIcon.addEventListener("click", toggleMenu);

  // リサイズ
  window.addEventListener("resize", handleResize);

  // 外クリック
  document.addEventListener("click", clickOuter);

  // 新・スクロール関数（.drawerScrollの中を動かす仕様）
  const linkScroll = (target) => {
    if (!target) return;

    // スクロールさせる全体の器（.drawerScroll）を取得
    const scrollContainer = document.querySelector(".drawerScroll") || window;

    if (scrollContainer === window) {
      // 万が一コンテナがない場合のフォールバック
      const targetPosition = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    } else {
      // .drawerScroll の中をスクロールさせる
      const containerTop = scrollContainer.getBoundingClientRect().top;
      const targetTop = target.getBoundingClientRect().top;
      // 現在のスクロール位置 + ターゲットの相対位置
      const scrollTarget = scrollContainer.scrollTop + (targetTop - containerTop);

      scrollContainer.scrollTo({
        top: scrollTarget,
        behavior: "smooth",
      });
    }
  };

  // 新・ページ内リンクのクリックイベント
  drawerNavItem.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();

      const targetItem = document.querySelector(item.getAttribute("href"));

      // 1. まずドロワーを閉じる（アニメーション開始。ここでbodyのlock解除などが予約されます）
      closeMenu();

      // 2. ドロワーが閉じるアニメーション（500ms）が終わるのを待ってからスクロール
      setTimeout(() => {
        linkScroll(targetItem);
      }, 50);
    });
  });
});

/* =============================================
商品のスライダー
============================================= */
// // 初期化・破壊を切り替える関数
// let swiperInstance = null;

// function toggleSwiper1() {
//   const isSP1 = window.matchMedia("(max-width: 767px)").matches;
//   const swiperEl1 = document.querySelector(".product__swiper");

//   if (isSP1) {
//     // SPサイズならSwiperを初期化
//     if (!swiperInstance) {
//       swiperInstance = new Swiper(swiperEl1, {
//         speed: 1000,
//         effect: "slide",
//         allowTouchMove: true,
//         loop: true,
//         autoplay: {
//           delay: 3000,
//           disableOnInteraction: false,
//         },

//         centeredSlides: true,
//         slidesPerView: 1,
//         spaceBetween: 0,
//         // spaceBetween: window.innerWidth * 0.094,

//         pagination: {
//           el: ".swiper-pagination",
//           clickable: true,
//           type: "bullets",
//         },
//         navigation: {
//           prevEl: ".swiper-button-prev",
//           nextEl: ".swiper-button-next",
//         },
//       });
//     }
//   } else {
//     // PCサイズならSwiperを破棄
//     if (swiperInstance) {
//       swiperInstance.destroy(true, true);
//       swiperInstance = null;

//       // SP用に付与されたクラスやスタイルを完全リセット
//       swiperEl1.classList.remove("swiper-initialized", "swiper-horizontal", "swiper-backface-hidden", "swiper-free-mode", "swiper-wp8-horizontal");
//       swiperEl1.querySelectorAll(".swiper-slide").forEach((slide) => {
//         slide.style.width = "";
//         slide.style.marginRight = "";
//       });

//       // 必要ならpaginationやnavigationもリセット
//       const pag = swiperEl1.querySelector(".swiper-pagination");
//       if (pag) pag.innerHTML = "";
//     }
//   }
//   const productSwiper = new Swiper(".productWrap", {
//     // ここは既存の設定に合わせて OK
//     on: {
//       slideChange: function () {
//         // 一旦全部非表示
//         const charas = document.querySelectorAll(".product__swiper-slide-chara");
//         charas.forEach((c) => (c.style.opacity = 0));

//         // active index に対応するキャラだけ表示
//         const activeIndex = this.activeIndex;
//         const activeChara = document.querySelector(`.product__swiper-slide-chara:nth-of-type(${activeIndex + 1})`);
//         if (activeChara) activeChara.style.opacity = 1;
//       },
//     },
//   });
// }

// // 初回実行
// toggleSwiper1();
// // リサイズ時も切り替え
// window.addEventListener("resize", toggleSwiper1);

// アコーディオン
document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
});

const setUpAccordion = () => {
  const details = document.querySelectorAll(".productItemFaqItem");
  const IS_OPENED_CLASS = "is-opened";
  const IS_ANIMATING_CLASS = "is-animating";

  details.forEach((element) => {
    const summary = element.querySelector(".productItemFaqItemQ");
    const content = element.querySelector(".productItemFaqItemA");

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      // アニメーション中は無効
      if (element.classList.contains(IS_ANIMATING_CLASS)) return;

      element.classList.add(IS_ANIMATING_CLASS);

      if (element.classList.contains(IS_OPENED_CLASS)) {
        // 閉じる
        const contentHeight = content.scrollHeight;

        content.style.height = contentHeight + "px";

        // reflow
        content.offsetHeight;

        content.style.height = "0";
        content.style.opacity = "0";

        element.classList.remove(IS_OPENED_CLASS);

        const onClose = (e) => {
          if (e.propertyName !== "height") return;

          element.removeAttribute("open");
            ScrollTrigger.refresh();

          content.removeEventListener("transitionend", onClose);

          element.classList.remove(IS_ANIMATING_CLASS);
        };

        content.addEventListener("transitionend", onClose);
      } else {
        // 開く
        element.setAttribute("open", "true");

        content.style.height = "0";
        content.style.opacity = "0";

        // reflow
        content.offsetHeight;

        const contentHeight = content.scrollHeight;

        content.style.height = contentHeight + "px";
        content.style.opacity = "1";

        element.classList.add(IS_OPENED_CLASS);

        const onOpen = (e) => {
          if (e.propertyName !== "height") return;

          content.style.height = "auto";
          ScrollTrigger.refresh();

          content.removeEventListener("transitionend", onOpen);

          element.classList.remove(IS_ANIMATING_CLASS);
        };

        content.addEventListener("transitionend", onOpen);
      }
    });
  });
};
